import type { ISchedule, WorkplaceRequestElement } from "@gettactic/api";

/**
 * A reservation is tied to a workplace request in two ways: a request filed
 * against it (the request carries the `schedule_id`) or a request whose
 * approval created it (the schedule carries an `origin` naming the request).
 *
 * The by-schedule endpoint only knows the first, so the creating request has
 * to be looked up on its own and added here. Only the gantt overview returns
 * `origin`, hence the pick on the incoming schedule rather than the refetched one.
 */
export const originRequestIdOf = (
  schedule: Pick<ISchedule, "origin"> | undefined
): string | undefined =>
  schedule?.origin?.type === "ticket" ? schedule.origin.id : undefined;

/**
 * The requests to show under a reservation: the one that created it first,
 * then the ones filed against it. A request present in both lists (core may
 * link it both ways one day) shows once.
 */
export const mergeReservationRequests = (
  filedAgainst: WorkplaceRequestElement[],
  createdBy: WorkplaceRequestElement | undefined
): WorkplaceRequestElement[] => {
  if (!createdBy) return filedAgainst;
  const rest = filedAgainst.filter((request) => request.id !== createdBy.id);
  return [createdBy, ...rest];
};
